import { render } from "./IconDirections.vue?vue&type=template&id=339dc4b0"
import script from "./IconDirections.vue?vue&type=script&lang=js"
export * from "./IconDirections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__